import * as yup from 'yup';
import {
  BenefitIncome,
  BUSINESS_TYPES,
  FIELDS,
  FosteringIncome,
  InvestmentIncome,
  MaintenanceIncome,
  OtherIncome,
  RentalIncome,
} from 'modules/cm/domain/Case/Applicant/Income/Current/Current';
import { nullableString } from 'utils/form/validation';
import { dateValidation } from 'utils/date';
import { FormModel } from 'modules/cm/form/Applicant/CurrentIncome/types';

export default yup.object().shape<FormModel>({
  [FIELDS.BASIC_GROSS_ANNUAL_SALARY]: nullableString(),
  [FIELDS.ANNUAL_BONUS]: nullableString(),
  [FIELDS.HAS_ANNUAL_BONUS_GUARANTEED]: yup.boolean().nullable(),
  [FIELDS.ANNUAL_COMMISSION]: nullableString(),
  [FIELDS.HAS_COMMISSION_GUARANTEED]: yup.boolean().nullable(),
  [FIELDS.ANNUAL_OVERTIME]: nullableString(),
  [FIELDS.HAS_OVERTIME_GUARANTEED]: yup.boolean().nullable(),
  [FIELDS.ANNUAL_SHIFT_ALLOWANCE]: nullableString(),
  [FIELDS.HAS_SHIFT_ALLOWANCE_GUARANTEED]: yup.boolean().nullable(),
  [FIELDS.BUSINESS_TYPE]: yup
    .mixed<BUSINESS_TYPES>()
    .oneOf(Object.values(BUSINESS_TYPES), '')
    .nullable(),
  [FIELDS.PERCENTAGE_OF_BUSINESS_OWNED]: nullableString(),
  [FIELDS.LIMITED_COMPANY_SALARY]: nullableString(),
  [FIELDS.LIMITED_COMPANY_DIVIDENDS]: nullableString(),
  [FIELDS.NET_PROFIT]: nullableString(),
  [FIELDS.BUSINESS_TRADING_DATE]: dateValidation().nullable(),
  [FIELDS.INVESTMENT_PREFIX]: yup.array().of(
    yup.object().shape<InvestmentIncome>({
      id: yup.number(),
      [FIELDS.INVESTMENT_PORTFOLIO_VALUE]: nullableString(),
      [FIELDS.INVESTMENT_ANNUAL_INVESTMENT_INCOME]: nullableString(),
      [FIELDS.INVESTMENT_ANNUAL_DIVIDEND_INCOME]: nullableString(),
    }),
  ),
  [FIELDS.RENTAL_PREFIX]: yup.array().of(
    yup.object().shape<RentalIncome>({
      id: yup.number(),
      [FIELDS.RENTAL_GROSS_ANNUAL_RENTAL_INCOME]: nullableString(),
      [FIELDS.RENTAL_NO_OF_BTLS_IN_PORTFOLIO]: nullableString(),
      [FIELDS.RENTAL_MORTGAGE_PAYMENT]: nullableString(),
    }),
  ),
  [FIELDS.FOSTERING_PREFIX]: yup.array().of(
    yup.object().shape<FosteringIncome>({
      id: yup.number(),
      [FIELDS.FOSTERING_GROSS_ANNUAL_FOSTERING_INCOME]: nullableString(),
    }),
  ),
  [FIELDS.MAINTENANCE_PREFIX]: yup.array().of(
    yup.object().shape<MaintenanceIncome>({
      id: yup.number(),
      [FIELDS.MAINTENANCE_GROSS_ANNUAL_MAINTENANCE_INCOME]: nullableString(),
      [FIELDS.HAS_MAINTENANCE_GUARANTEED_OTHER_INCOME]: yup.boolean().nullable(),
    }),
  ),
  [FIELDS.BENEFIT_PREFIX]: yup.array().of(
    yup.object().shape<BenefitIncome>({
      id: yup.number(),
      [FIELDS.BENEFIT_GROSS_ANNUAL_BENEFIT_INCOME]: nullableString(),
      [FIELDS.HAS_BENEFIT_GUARANTEED_OTHER_INCOME]: yup.boolean().nullable(),
    }),
  ),
  [FIELDS.OTHER_PREFIX]: yup.array().of(
    yup.object().shape<OtherIncome>({
      id: yup.number(),
      [FIELDS.OTHER_GROSS_ANNUAL_OTHER_INCOME]: nullableString(),
      [FIELDS.OTHER_HAS_BONUS_GUARANTEED_OTHER_INCOME]: yup.boolean().nullable(),
    }),
  ),
});
